module.exports = __webpack_public_path__ + "static/media/img_1.dc15cf01.png";